import { gql } from '@apollo/client'

export const CHART1_1_QUERY = gql`
  query m2CasesTotalCount($groupBy: M2CaseGroupBy, $filter: M2CaseStatisticFilter) {
    m2CasesTotalCount(groupBy: $groupBy, filter: $filter) {
      series {
        color
        title
        casesAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
